import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from './views/Home.vue';
import Draw from './views/Draw.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
  },
  {
    path: '/draw',
    name: 'Draw',
    component: Draw,
  },
  {
    path: '*',
    name: 'Error',
    component: () => (
      import(/* webpackChunkName: "error" */ '@/views/Error.vue')
    ),
  },
];

const router = new VueRouter({
  routes,
});

export default router;
